import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useVacationModuleAccess } from '@/features/Vacations/hooks/useVacationModuleAccess';
import { useIsVacationManager } from '@/features/Vacations/hooks/useIsVacationManager';
import { DP_PORTAL_TABS, getVisibleDpPortalTabs } from '../dpPortal.definitions';

export function useDpPortalTabs() {
    const { userHasRole } = useAuth();
    const { canSeeModule, isLoading: isModuleAccessLoading } = useVacationModuleAccess();
    const { isManager, isLoading: isManagerLoading } = useIsVacationManager();

    const tabs = useMemo(
        () => getVisibleDpPortalTabs(DP_PORTAL_TABS, { canSeeModule, isManager, hasRole: userHasRole }),
        [canSeeModule, isManager, userHasRole]
    );

    return {
        tabs,
        isModuleAccessLoading,
        isLoading: isModuleAccessLoading || isManagerLoading,
    };
}
